import React from 'react'
import './index.scss';

export interface IIconProps {
    className?: string;
}

export const MenuIcon = (props: IIconProps) => {
    const className = props.className ? "menu-icon " + props.className : "menu-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="62" height="41" viewBox="0 0 62 41">
            <g transform="translate(2.5 2.5)">
                <path className="a" d="M-13410-3080h56.833" transform="translate(13410 3114)" />
                <path className="a" d="M-13410-3080h48.666" transform="translate(13410 3097)" />
                <path className="a" d="M-13410-3080h34" transform="translate(13410 3080)" />
            </g>
        </svg>
    )
}

export const UserIcon = (props: IIconProps) => {
    const className = props.className ? "user-icon " + props.className : "user-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="41.185" height="45.708" viewBox="0 0 41.185 45.708">
            <g transform="translate(-3.5 -2)">
                <path className="a" d="M42.185,36.069V31.546A9.046,9.046,0,0,0,33.139,22.5H15.046A9.046,9.046,0,0,0,6,31.546v4.523" transform="translate(0 9.139)" />
                <path className="a" d="M30.093,13.546A9.046,9.046,0,1,1,21.046,4.5,9.046,9.046,0,0,1,30.093,13.546Z" transform="translate(3.046)" />
            </g>
        </svg>
    );
}

export const NotificationEmptyIcon = (props: IIconProps) => {
    const className = props.className ? "notification-empty-icon " + props.className : "notification-empty-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="52" height="61.455" viewBox="0 0 52 61.455">
            <path className="a" d="M31.773,14.081a21.356,21.356,0,0,1,3.532.662A15.055,15.055,0,0,1,46.78,29.493V48.345l1.377,1.383,1.151,1.156H13.942l1.151-1.156,1.377-1.383V29.493A15.055,15.055,0,0,1,27.945,14.743a26.152,26.152,0,0,1,3.532-.662m.148-10.706a4.516,4.516,0,0,0-4.588,4.609v2.151A19.916,19.916,0,0,0,11.743,29.493v16.9L5.625,52.539v3.073h52V52.539l-6.118-6.145v-16.9A19.916,19.916,0,0,0,36.213,10.135V7.984a4.516,4.516,0,0,0-4.588-4.609Zm6.118,55.309H25.507a6.118,6.118,0,1,0,12.235,0Z" transform="translate(-5.625 -3.375)" />
        </svg>
    );
}

export const CheckIcon = (props: IIconProps) => {
    const className = props.className ? "check-icon " + props.className : "check-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="53.333" height="53.333" viewBox="0 0 53.333 53.333">
            <path className="a" d="M29.667,3A26.667,26.667,0,1,0,56.333,29.667,26.676,26.676,0,0,0,29.667,3ZM24.333,43,11,29.667l3.76-3.76,9.573,9.547,20.24-20.24L48.333,19Z" transform="translate(-3 -3)" />
        </svg>
    );
}

export const FeatherEyeIcon = (props: IIconProps) => {
    const className = props.className ? "feather-eye-icon " + props.className : "feather-eye-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="62.4" height="46.473" viewBox="0 0 62.4 46.473">
            <g transform="translate(2 2)">
                <path className="a" d="M1.5,27.236S12.118,6,30.7,6,59.9,27.236,59.9,27.236,49.282,48.473,30.7,48.473,1.5,27.236,1.5,27.236Z" transform="translate(-1.5 -6)" />
                <path className="a" d="M29.427,21.464A7.964,7.964,0,1,1,21.464,13.5,7.964,7.964,0,0,1,29.427,21.464Z" transform="translate(7.736 -0.227)" />
            </g>
        </svg>
    );
}

export const FeatherTrashIcon = (props: IIconProps) => {
    const className = props.className ? "feather-trash-icon " + props.className : "feather-trash-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="44.542" height="49.047" viewBox="0 0 44.542 49.047">
            <g transform="translate(2 2)">
                <path className="a" d="M4.5,9H45.042" transform="translate(-4.5 0.009)" />
                <path className="a" d="M39.033,12.009V43.542a4.5,4.5,0,0,1-4.5,4.5H12a4.5,4.5,0,0,1-4.5-4.5V12.009m6.757,0V7.5a4.5,4.5,0,0,1,4.5-4.5h9.009a4.5,4.5,0,0,1,4.5,4.5v4.5" transform="translate(-2.995 -3)" />
                <path className="a" d="M15,16.5V30.014" transform="translate(0.766 3.771)" />
                <path className="a" d="M21,16.5V30.014" transform="translate(3.776 3.771)" />
            </g>
        </svg>
    );
}

export const FeatherUploadIcon = (props: IIconProps) => {
    const className = props.className ? "feather-upload-icon " + props.className : "feather-upload-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="46.5" height="46.5" viewBox="0 0 46.5 46.5">
            <g transform="translate(-1.5 -1.5)">
                <path className="a" d="M45,22.5v9A4.5,4.5,0,0,1,40.5,36H9a4.5,4.5,0,0,1-4.5-4.5v-9" transform="translate(0 9)" />
                <path className="a" d="M33,15.75,21.75,4.5,10.5,15.75" transform="translate(3 0)" />
                <path className="a" d="M18,4.5v27" transform="translate(6.75 0)" />
            </g>
        </svg>
    );
}

export const InfoAwesomeIcon = (props: IIconProps) => {
    const className = props.className ? "info-awesome-icon " + props.className : "info-awesome-icon";
    return (
        <svg className={className} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
            <path className="a" opacity="0" d="M49 28C49 39.598 39.598 49 28 49C16.402 49 7 39.598 7 28C7 16.402 16.402 7 28 7C39.598 7 49 16.402 49 28Z" transform="translate(-0.563 -0.563)" />
            <path className="a" d="M28.75 39.6433C28.75 39.2291 28.4142 38.8933 28 38.8933C27.5858 38.8933 27.25 39.2291 27.25 39.6433H28.75ZM27.25 39.6666C27.25 40.0808 27.5858 40.4166 28 40.4166C28.4142 40.4166 28.75 40.0808 28.75 39.6666H27.25ZM28.75 16.3333C28.75 15.9191 28.4142 15.5833 28 15.5833C27.5858 15.5833 27.25 15.9191 27.25 16.3333H28.75ZM27.25 32.6667C27.25 33.0809 27.5858 33.4167 28 33.4167C28.4142 33.4167 28.75 33.0809 28.75 32.6667H27.25ZM27.25 39.6433V39.6666H28.75V39.6433H27.25ZM27.25 16.3333V32.6667H28.75V16.3333H27.25ZM48.25 28C48.25 39.1838 39.1838 48.25 28 48.25V49.75C40.0122 49.75 49.75 40.0122 49.75 28H48.25ZM28 48.25C16.8162 48.25 7.75 39.1838 7.75 28H6.25C6.25 40.0122 15.9878 49.75 28 49.75V48.25ZM7.75 28C7.75 16.8162 16.8162 7.75 28 7.75V6.25C15.9878 6.25 6.25 15.9878 6.25 28H7.75ZM28 7.75C39.1838 7.75 48.25 16.8162 48.25 28H49.75C49.75 15.9878 40.0122 6.25 28 6.25V7.75Z" transform="translate(-0.563 -0.563)" />
        </svg>

        // OLD ICON 
        // <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79.313 79.313">
        //     <path className="a" d="M40.219.562A39.656,39.656,0,1,0,79.875,40.219,39.662,39.662,0,0,0,40.219.562Zm0,17.589A6.716,6.716,0,1,1,33.5,24.868,6.716,6.716,0,0,1,40.219,18.152Zm8.955,40.616a1.919,1.919,0,0,1-1.919,1.919H33.183a1.919,1.919,0,0,1-1.919-1.919V54.93a1.919,1.919,0,0,1,1.919-1.919H35.1V42.777H33.183a1.919,1.919,0,0,1-1.919-1.919V37.021A1.919,1.919,0,0,1,33.183,35.1H43.417a1.919,1.919,0,0,1,1.919,1.919v15.99h1.919a1.919,1.919,0,0,1,1.919,1.919Z" transform="translate(-0.563 -0.563)" />
        // </svg>
    );
}

export const WebIcon = (props: IIconProps) => {
    const className = props.className ? "web-icon " + props.className : "web-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.254 42.381">
            <g id="web" transform="translate(0.25 0.25)">
                <path className="a" id="Tracé_1042" data-name="Tracé 1042" d="M3414.035,827.258a1,1,0,0,1-1-1V786.411a1,1,0,1,1,2,0v39.849A1,1,0,0,1,3414.035,827.258Z" transform="translate(-3393.158 -785.412)" />
                <path className="a" id="Tracé_1041" data-name="Tracé 1041" d="M3435.678,805.579H3395.92a1,1,0,0,1,0-2h39.758a1,1,0,0,1,0,2Z" transform="translate(-3394.922 -783.641)" />
                <path className="a" id="Tracé_1040" data-name="Tracé 1040" d="M3415.036,827.255a.99.99,0,0,1-.474-.12c-6.832-3.672-11.79-12.414-11.79-20.786s4.958-17.115,11.79-20.787a1,1,0,0,1,.945,0c6.831,3.672,11.788,12.415,11.788,20.787s-4.957,17.114-11.788,20.786A.988.988,0,0,1,3415.036,827.255Zm0-39.669c-5.978,3.488-10.266,11.277-10.266,18.763s4.288,15.275,10.266,18.763c5.976-3.489,10.265-11.279,10.265-18.763S3421.011,791.074,3415.036,787.586Z" transform="translate(-3394.158 -785.409)" />
                <path className="a" id="Tracé_1039" data-name="Tracé 1039" d="M3415.8,827.293h-.006a20.877,20.877,0,1,1,.006,0Zm-.006-39.885a18.944,18.944,0,1,0,18.884,18.944A18.975,18.975,0,0,0,3415.8,787.408Z" transform="translate(-3394.922 -785.412)" />
            </g>
        </svg>
    );
}

export const PlayIcon = (props: IIconProps) => {
    const className = props.className ? "play-icon " + props.className : "play-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="45.214" height="45.214" viewBox="0 0 45.214 45.214">
            <g id="play" transform="translate(1.25 1.25)">
                <g id="Icon_feather-play-circle" data-name="Icon feather-play-circle">
                    <path className="a" id="Tracé_1327" data-name="Tracé 1327" d="M45.714,24.357A21.357,21.357,0,1,1,24.357,3,21.357,21.357,0,0,1,45.714,24.357Z" transform="translate(-3 -3)" />
                    <path className="a" id="Tracé_1328" data-name="Tracé 1328" d="M15,12l12.814,8.543L15,29.086Z" transform="translate(2.086 0.814)" />
                </g>
            </g>
        </svg>
    );
}

export const PhoneCallIcon = (props: IIconProps) => {
    const className = props.className ? "phone-call-icon " + props.className : "phone-call-icon";
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="43.607" height="43.689" viewBox="0 0 43.607 43.689">
            <path className="a" id="phone-call" d="M44.27,34.418v6.2a4.133,4.133,0,0,1-4.505,4.133,40.9,40.9,0,0,1-17.836-6.345,40.3,40.3,0,0,1-12.4-12.4A40.9,40.9,0,0,1,3.185,8.088,4.133,4.133,0,0,1,7.3,3.583h6.2a4.133,4.133,0,0,1,4.133,3.555,26.536,26.536,0,0,0,1.447,5.807,4.133,4.133,0,0,1-.93,4.361L15.523,19.93a33.067,33.067,0,0,0,12.4,12.4l2.625-2.625a4.133,4.133,0,0,1,4.361-.93,26.536,26.536,0,0,0,5.807,1.447A4.133,4.133,0,0,1,44.27,34.418Z" />
        </svg>
    );
}
// <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88"><defs><style>.cls-1{fill:#444;fill-rule:evenodd;}</style></defs><title>close</title><path class="cls-1" d="/></svg>

export const CloseIcon = (props: IIconProps) => {
    const className = props.className ? "close-icon " + props.className : "close-icon";
    return (
        // <svg className={className} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"  viewBox="0 0 122.88 122.88">
        //     <path className="a" d="M61.44,0A61.44,61.44,0,1,1,0,61.44,61.44,61.44,0,0,1,61.44,0ZM74.58,36.8c1.74-1.77,2.83-3.18,5-1l7,7.13c2.29,2.26,2.17,3.58,0,5.69L73.33,61.83,86.08,74.58c1.77,1.74,3.18,2.83,1,5l-7.13,7c-2.26,2.29-3.58,2.17-5.68,0L61.44,73.72,48.63,86.53c-2.1,2.15-3.42,2.27-5.68,0l-7.13-7c-2.2-2.15-.79-3.24,1-5l12.73-12.7L36.35,48.64c-2.15-2.11-2.27-3.43,0-5.69l7-7.13c2.15-2.2,3.24-.79,5,1L61.44,49.94,74.58,36.8Z" />
        // </svg>
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px">
            <path className="a" d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z" />
        </svg>
    );
}